import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration, withEventReplay, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './interceptors/auth.interceptors';
import { TitleStrategy, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { NoCacheInterceptor } from './interceptors/no-cache.interceptors';
import { LOCATION_REPOSITORY } from './services/location-repository';
import { GooglePlacesService } from './services/google-places.service';
import { AppTitleStrategy } from './core/seo/app-title.strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // Restores scroll on back/forward, scrolls to top on new navigations.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      // Same-URL navigations (e.g. tapping the active category again) re-run guards/resolvers
      // only when query params change, never a full reload.
      withRouterConfig({ onSameUrlNavigation: 'ignore' }),
    ),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    // SSR responses for public GETs are reused during hydration instead of being refetched.
    // Authenticated requests are excluded so per-user data is never embedded in shared HTML.
    provideClientHydration(withEventReplay(), withHttpTransferCacheOptions({ includePostRequests: false })),
    provideHttpClient(withFetch(), withInterceptors([AuthInterceptor, NoCacheInterceptor])),
    provideAnimations(),
    provideToastr({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      progressBar: false,
      extendedTimeOut: 2000,
      tapToDismiss: true,
      maxOpened: 3,
    }),
    { provide: LOCATION_REPOSITORY, useClass: GooglePlacesService },
  ]
};
